import { Injectable } from '@angular/core';
import { Http} from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'

@Injectable()
export class SimuladorCuentasPorCobrarProvider {
    token:string
    urlPrintService:string
    companiaId:number
    usuarioId: number;

    constructor(
        public http: Http, private storage:Storage,
       ) {
        this.storage.get('token').then((val) => {
            this.token = val
        });

        this.storage.get('companiasId').then(async (val) => {
            this.companiaId = val
        })

        this.storage.get('urlPrint').then((val) => {
            this.urlPrintService = val
        });

        this.storage.get('usuariosId').then((usuario) => {
            this.usuarioId = usuario
        });

    }

    async calcularPlanDePagos(valorTotalVenta:number,monto: number, numeroDeCuotas: number,
      periodicidadEnCadena: string, periodoDeGracia:number, cuotasExtrasArray: any[]) {
      return new Promise((resolve, reject) => {
      const montoDeCuota = monto
      const periodicidad = this.devolverNumeroDePeriodicidad(periodicidadEnCadena)
      let planDePagos = [];
      let montoRestante = monto;
      let totalPagado = 0;
      let montoDeCuotaActual = 0

      for (let cuota = 1; cuota <= numeroDeCuotas + periodoDeGracia; cuota++) {
        let fechaDeVencimiento = new Date(); // Obtener una nueva instancia de fecha para cada cuota
        fechaDeVencimiento.setMonth(fechaDeVencimiento.getMonth() + (periodicidad * (cuota))); // Cambiar la fecha de vencimiento para cada cuota
        if(cuota <= periodoDeGracia) {
          planDePagos.push({
            numeroDeCuota: cuota,
            montoDeLaCuota: montoDeCuotaActual,
            fechaDeVencimiento: fechaDeVencimiento,
            capitalRestante: 0,
            totalPagado: totalPagado
          });
        }

      }

      for (let cuota = 1; cuota <= numeroDeCuotas; cuota++) {
        let fechaDeVencimiento = new Date(); // Obtener una nueva instancia de fecha para cada cuota
        fechaDeVencimiento.setMonth(fechaDeVencimiento.getMonth() + (periodicidad * (cuota + periodoDeGracia))); // Cambiar la fecha de vencimiento para cada cuota
        totalPagado += montoDeCuota;
        montoRestante = valorTotalVenta - totalPagado;
        let sumaMontos = 0

        // Iterar a través de todos los registros en planDePagos
        planDePagos.forEach(item => {
            sumaMontos = sumaMontos + item.montoDeLaCuota;
        });

        // Iterar a través de todos los registros en cuotasExtrasArray
        cuotasExtrasArray.forEach(cuotaExtra => {
          sumaMontos = sumaMontos + Number(cuotaExtra.montoDeLaCuota);
        });

        if(cuota === Number(numeroDeCuotas) ) {

          let valorUltimaCalculado = valorTotalVenta - sumaMontos < 0 ? 0 : (valorTotalVenta - sumaMontos)
          planDePagos.push({
            numeroDeCuota: cuota + periodoDeGracia,
            montoDeLaCuota: valorUltimaCalculado < 0 ? 0 : valorUltimaCalculado,
            fechaDeVencimiento: fechaDeVencimiento,
            capitalRestante: 0,
            totalPagado: 0
          });
      } else {
        let montoDeCuotaCalculado = valorTotalVenta - Number(sumaMontos) > 0 ? montoDeCuota : 0
        montoDeCuotaCalculado = montoDeCuotaCalculado + sumaMontos > valorTotalVenta ?  valorTotalVenta - sumaMontos : montoDeCuotaCalculado
        totalPagado = valorTotalVenta < totalPagado ? valorTotalVenta : totalPagado
        planDePagos.push({
          numeroDeCuota: cuota + periodoDeGracia,
          montoDeLaCuota: montoDeCuotaCalculado < 0 ? monto: montoDeCuotaCalculado,
          fechaDeVencimiento: fechaDeVencimiento,
          capitalRestante: montoRestante < 0 ? 0 : montoRestante,
          totalPagado: montoDeCuotaCalculado === 0 ? 0 : totalPagado
        });
      }

      }
      planDePagos[0].montoDeLaCuota = periodoDeGracia > 0 ? 0 : monto;
      resolve(planDePagos); // Resuelve la Promise con los datos del plan de pagos una vez que estén listos
    });
    }


    calcularValorSegunPeriodicidad(periodicidad: string) {

      let cuotas: number;
      if (periodicidad === 'm') {
        cuotas = 12 * 8; // 12 cuotas por año, hasta 8 años
      } else if (periodicidad === 'b') {
        cuotas = 6 * 8; // 6 cuotas por año (bimensual), hasta 8 años
      } else if (periodicidad === 't') {
        cuotas = 4 * 8; // 4 cuotas por año (trimestral), hasta 8 años
      } else if (periodicidad === 'q') {
        cuotas = 24 * 8; // 24 cuotas por año, hasta 8 años (quincenal)
      } else {
        cuotas = 12 * 8; // 12 cuotas por año, hasta 8 años
        return;
      }
      return cuotas
    }



    devolverNombrePeriodicidad(periodicidad: string) {
      let periodoLetras = ''
      if (periodicidad === 'm') {
        periodoLetras = 'MENSUAL'
      } else if (periodicidad === 'b') {
        periodoLetras = 'BIMESTRAL'
      } else if (periodicidad === 't') {
        periodoLetras = 'TRIMESTRAL'
      } else if (periodicidad === 'q') {
        periodoLetras = 'QUINCENAL'
      } else {
        periodoLetras = 'MENSUAL'
        return;
      }
      return periodoLetras
    }


    devolverNumeroDePeriodicidad(periodicidadEnCadena: string): number {
      let periodicidad = 1
      if (periodicidadEnCadena === 'm') {
        periodicidad = 1
      } else if (periodicidadEnCadena === 'b') {
        periodicidad = 2
      } else if (periodicidadEnCadena === 't') {
        periodicidad = 3
      } else if (periodicidadEnCadena === 'q') {
        periodicidad = 0.5; // Quincenal (2 quincenas por mes)
      } else {
        periodicidad = 1
        return;
      }
      return periodicidad
    }

    cambiarFechaDiaDePago(diaDePago: number, planDePagos: any): any {
      let nuevoPlanDePagos = [];

      for (let item = 0; item < planDePagos.length; item++) {
        let fechaDeVencimiento = new Date(planDePagos[item].fechaDeVencimiento);
        fechaDeVencimiento.setDate(1); // Establecer el día al 1 para evitar problemas con los meses de menos días

        // Si el día de pago es mayor que el último día del mes, se establece el día al último día del mes
        if (diaDePago > new Date(fechaDeVencimiento.getFullYear(), fechaDeVencimiento.getMonth() + 1, 0).getDate()) {
          fechaDeVencimiento.setDate(new Date(fechaDeVencimiento.getFullYear(), fechaDeVencimiento.getMonth() + 1, 0).getDate());
        } else {
          fechaDeVencimiento.setDate(diaDePago);
        }

        nuevoPlanDePagos.push({
          numeroDeCuota: planDePagos[item].numeroDeCuota,
          montoDeLaCuota: planDePagos[item].montoDeLaCuota,
          fechaDeVencimiento: fechaDeVencimiento,
          capitalRestante: planDePagos[item].capitalRestante,
          totalPagado: planDePagos[item].totalPagado
        });
      }

      return nuevoPlanDePagos;
    }

    validarCuotasExtras(
      valorTotal:number,
      valorCuota: number,
      valorCuotaExtra: number = 0,
      numeroDeCuotaExtra: number,
      cuotasExtrasArray: any[],
      planDePagos: any[],
      periodoDeGracia:number
    ): any {
      let sumaCuotas = 0;
      let sumaCuotasExtras = 0
      let posicionCuotaExtra = numeroDeCuotaExtra - 1
      for (let item = 0; item < planDePagos.length; item++) {
        const coincide = this.verificarCoincidenciaDeCuota(planDePagos, cuotasExtrasArray, item)
        if(!coincide){
          if(item + 1 !== planDePagos.length){
            sumaCuotas += Number(planDePagos[item].montoDeLaCuota) < 0 || (Number(planDePagos[item].totalPagado) <= valorTotal) ? valorCuota : Number(planDePagos[item].montoDeLaCuota);
            planDePagos[item].montoDeLaCuota = Number(planDePagos[item].montoDeLaCuota) < 0 || (Number(planDePagos[item].totalPagado) <= valorTotal) ? valorCuota : Number(planDePagos[item].montoDeLaCuota);
          }
        } else {
          planDePagos[item].montoDeLaCuota = 0
        }

        if(item + 1 === planDePagos.length) {
            for (let cuotaExtra of cuotasExtrasArray) {
              if(cuotaExtra.numeroDeCuotaExtrasReal === numeroDeCuotaExtra) {
                sumaCuotasExtras += Number(cuotaExtra.montoDeLaCuota) < 0 ? valorCuota : Number(cuotaExtra.montoDeLaCuota);
              }
            }
              let capitalRestante =  planDePagos[posicionCuotaExtra].capitalRestante
              let totalPagado =  planDePagos[posicionCuotaExtra].totalPagado
              if( capitalRestante - (valorCuotaExtra - valorCuota) < 0) {
                planDePagos[posicionCuotaExtra].montoDeLaCuota = valorCuota;
                capitalRestante = planDePagos[posicionCuotaExtra].capitalRestante
                totalPagado = planDePagos[posicionCuotaExtra].totalPagado
              } else {
                planDePagos[posicionCuotaExtra].montoDeLaCuota = valorCuotaExtra;
                planDePagos[posicionCuotaExtra].capitalRestante = capitalRestante - (valorCuotaExtra - valorCuota)
                planDePagos[posicionCuotaExtra].totalPagado = totalPagado + (valorCuotaExtra - valorCuota)
                capitalRestante = planDePagos[posicionCuotaExtra].capitalRestante
                totalPagado = planDePagos[posicionCuotaExtra].totalPagado
              }


              if(posicionCuotaExtra + 1 < planDePagos.length) {
                let posicionNueva = posicionCuotaExtra + 1
                for (let itemRecalcular = posicionNueva; itemRecalcular < planDePagos.length; itemRecalcular++) {
                  if(totalPagado + valorCuota >= valorTotal) {
                    planDePagos[itemRecalcular].montoDeLaCuota = valorTotal - totalPagado < 0 ? 0 :  valorTotal - totalPagado
                    planDePagos[itemRecalcular].capitalRestante = 0
                    planDePagos[itemRecalcular].totalPagado = valorTotal
                    let nuevoItemRecalcular = itemRecalcular + 1
                    itemRecalcular = planDePagos.length + 1
                    for (nuevoItemRecalcular; nuevoItemRecalcular < planDePagos.length; nuevoItemRecalcular++) {
                      planDePagos[nuevoItemRecalcular].montoDeLaCuota = 0
                      planDePagos[nuevoItemRecalcular].capitalRestante = 0
                      planDePagos[nuevoItemRecalcular].totalPagado = 0
                    }

                  } else {
                    planDePagos[itemRecalcular].capitalRestante =  capitalRestante - valorCuota
                    planDePagos[itemRecalcular].totalPagado =  totalPagado + valorCuota
                    capitalRestante = planDePagos[itemRecalcular].capitalRestante
                    totalPagado =  planDePagos[itemRecalcular].totalPagado
                    if(itemRecalcular === planDePagos.length - 1) {
                      let sumaMontoDeLaCuota = planDePagos.reduce((total, cuota) => total + Number(cuota.montoDeLaCuota), 0);
                      if(sumaMontoDeLaCuota < valorTotal) {
                        planDePagos[itemRecalcular].montoDeLaCuota = valorTotal - sumaMontoDeLaCuota
                        planDePagos[itemRecalcular].capitalRestante = 0
                        planDePagos[itemRecalcular].totalPagado = 0
                      } else {
                        planDePagos[itemRecalcular].montoDeLaCuota =
                        Number(planDePagos[itemRecalcular].capitalRestante) + Number(planDePagos[itemRecalcular].totalPagado) == valorTotal
                         ? planDePagos[itemRecalcular].capitalRestante + valorCuota : 0
                        planDePagos[itemRecalcular].capitalRestante = 0
                        planDePagos[itemRecalcular].totalPagado = 0
                      }
                     }
                  }

                }
                planDePagos[0].montoDeLaCuota = periodoDeGracia > 0 ? 0 : valorCuota;
                this.verificarCoincidenciaDeCuotaRecalculadoSaldosDeLasExtras(planDePagos,cuotasExtrasArray, periodoDeGracia)
              }
          }
      }
      return planDePagos;
    }

    verificarCoincidenciaDeCuota(planDePagos: any, cuotasExtrasArray: any, posicionRecorrido:any): boolean {
      for (const cuotaExtra of cuotasExtrasArray) {
        const cuotaCorrespondiente = planDePagos.find((cuota) => Number(cuota.numeroDeCuota) === Number(cuotaExtra.numeroDeCuotaExtrasReal) - 1 &&  Number(cuotaExtra.numeroDeCuotaExtrasReal) - 1 === posicionRecorrido);
        if (cuotaCorrespondiente) {
          return true;
        }
      }
      return false;
    }

    verificarCoincidenciaDeCuotaRecalculadoSaldosDeLasExtras(planDePagos: any[], cuotasExtrasArray: any[], periodoDeGracia:any) {
      cuotasExtrasArray.forEach((cuotaExtra) => {
        const posicion = cuotaExtra.numeroDeCuotaExtrasReal - 1;
        if (posicion < planDePagos.length) {
          planDePagos[posicion].montoDeLaCuota = cuotaExtra.montoDeLaCuota;
        }
      });

      if (periodoDeGracia > 0) { // Verificar si hay periodo de gracia
        for (let i = 0; i < periodoDeGracia && i < planDePagos.length; i++) {
          planDePagos[i].montoDeLaCuota = 0; // Actualizar montoDeLaCuota a 0 para los primeros ítems según el periodo de gracia
        }
      }

      return planDePagos; // Devolver el array de planDePagos con las cantidades actualizadas
    }


    // async calcularPlanDePagosConInteres(valorTotalVenta:number,monto: any, listaProductosSeleccionados: any[]) {
    //   return new Promise((resolve, reject) => {
    //   // Calcular el monto de cada cuota

    //   const montoDeCuota = monto.valorCuota
    //   const periodicidad = 1
    //   let planDePagos = [];
    //   let montoRestante = monto.valorCuota;
    //   let totalPagado = 0;
    //   let montoDeCuotaActual = 0

    //   for (let cuota = 1; cuota <= monto.numeroDeCuotas; cuota++) {
    //     let fechaDeVencimiento = new Date(); // Obtener una nueva instancia de fecha para cada cuota
    //     fechaDeVencimiento.setMonth(fechaDeVencimiento.getMonth() + (periodicidad * (cuota))); // Cambiar la fecha de vencimiento para cada cuota
    //       planDePagos.push({
    //         numeroDeCuota: cuota,
    //         montoDeLaCuota: montoDeCuotaActual,
    //         fechaDeVencimiento: fechaDeVencimiento,
    //         capitalRestante: 0,
    //         totalPagado: totalPagado
    //       });
    //   }

    //   for (let cuota = 1; cuota <= monto.numeroCuota; cuota++) {
    //     let fechaDeVencimiento = new Date(); // Obtener una nueva instancia de fecha para cada cuota
    //     fechaDeVencimiento.setMonth(fechaDeVencimiento.getMonth() + (periodicidad * (cuota))); // Cambiar la fecha de vencimiento para cada cuota
    //     totalPagado += montoDeCuota;
    //     montoRestante = valorTotalVenta - totalPagado;
    //     let sumaMontos = 0

    //     // Iterar a través de todos los registros en planDePagos
    //     planDePagos.forEach(item => {
    //         sumaMontos = sumaMontos + item.montoDeLaCuota;
    //     });



    //     if(cuota === Number(monto.numeroCuota) ) {

    //       let valorUltimaCalculado = valorTotalVenta - sumaMontos < 0 ? 0 : (valorTotalVenta - sumaMontos)
    //       planDePagos.push({
    //         numeroDeCuota: cuota,
    //         montoDeLaCuota: valorUltimaCalculado < 0 ? 0 : valorUltimaCalculado,
    //         fechaDeVencimiento: fechaDeVencimiento,
    //         capitalRestante: 0,
    //         totalPagado: 0
    //       });
    //   } else {
    //     let montoDeCuotaCalculado = valorTotalVenta - Number(sumaMontos) > 0 ? montoDeCuota : 0
    //     montoDeCuotaCalculado = montoDeCuotaCalculado + sumaMontos > valorTotalVenta ?  valorTotalVenta - sumaMontos : montoDeCuotaCalculado
    //     totalPagado = valorTotalVenta < totalPagado ? valorTotalVenta : totalPagado
    //     planDePagos.push({
    //       numeroDeCuota: cuota,
    //       montoDeLaCuota: montoDeCuotaCalculado < 0 ? monto: montoDeCuotaCalculado,
    //       fechaDeVencimiento: fechaDeVencimiento,
    //       capitalRestante: montoRestante < 0 ? 0 : montoRestante,
    //       totalPagado: montoDeCuotaCalculado === 0 ? 0 : totalPagado
    //     });
    //   }

    //   }
    //   const totalValorVentaReal = listaProductosSeleccionados.reduce((acc, producto) => {
    //     return acc + (producto.cantidad * producto.valorVenta);
    //   }, 0);
    //   let posicion = planDePagos.length - 1
    //   let valorTotalDeLaVentaSinIntereses = totalValorVentaReal

    //   let interesnuevo = monto.valor;

    //   // Convierte el porcentaje de interés a un decimal
    //   const interes = interesnuevo / 100;


    //   const totalValorVentaRealnuevo = totalValorVentaReal;

    //   const valorTotalInteres = totalValorVentaRealnuevo * interes;

    //   let valorTotalDeLaVentaConIntereses = monto.valorCuota * monto.numeroCuota
    //   if(valorTotalDeLaVentaConIntereses > valorTotalDeLaVentaSinIntereses) {
    //     let descuento = valorTotalDeLaVentaConIntereses - valorTotalDeLaVentaSinIntereses
    //     planDePagos[posicion].montoDeLaCuota = planDePagos[posicion].montoDeLaCuota + valorTotalInteres - descuento
    //     planDePagos[posicion].totalPagado = valorTotalDeLaVentaSinIntereses + valorTotalInteres
    //   } else {
    //     planDePagos[posicion].totalPagado = valorTotalDeLaVentaConIntereses
    //   }
    //   valorTotalVenta = planDePagos[posicion].totalPagado
    //   resolve(planDePagos); // Resuelve la Promise con los datos del plan de pagos una vez que estén listos
    // });
    // }
    // afnarqui
    async calcularPlanDePagosConInteres(valorTotalVenta: number, monto: any, listaProductosSeleccionados: any[]) {
      return new Promise((resolve, reject) => {
        const tasaEfectivaAnual = monto.valor / 100; // TEA proporcionada en el objeto monto
        const numeroDeCuotas = monto.numeroCuota;
        const periodicidad = 12; // Mensual, por ejemplo

// Convertir TEA a tasa nominal periódica
const tasaInteresPeriodica = Math.pow(1 + tasaEfectivaAnual, 1 / periodicidad) - 1;

        // Calcular la cuota fija usando la fórmula de amortización
const montoDeCuotaSinRedondeo = (valorTotalVenta * tasaInteresPeriodica *
  Math.pow(1 + tasaInteresPeriodica, numeroDeCuotas)) /
  (Math.pow(1 + tasaInteresPeriodica, numeroDeCuotas) - 1);

          // Redondea la cuota al múltiplo de 100 más cercano
        const montoDeCuota = Math.ceil(montoDeCuotaSinRedondeo / 100) * 100;

        let planDePagos = [];
        let montoRestante = valorTotalVenta;
        let totalPagado = 0;

        for (let cuota = 1; cuota <= numeroDeCuotas; cuota++) {
          let fechaDeVencimiento = new Date();
          fechaDeVencimiento.setMonth(fechaDeVencimiento.getMonth() + cuota);

          // Calcular interés y abono a capital para la cuota actual
          let interesCuota = montoRestante * tasaInteresPeriodica;
          let abonoCapital = montoDeCuota - interesCuota;

          // Reducir el capital restante
          montoRestante -= abonoCapital;
          // Actualizar el total pagado
          totalPagado += montoDeCuota;

          planDePagos.push({
            numeroDeCuota: cuota,
            montoDeLaCuota: montoDeCuota,
            abonoCapital: abonoCapital,
            abonoInteres: interesCuota,
            fechaDeVencimiento: fechaDeVencimiento,
            capitalRestante: montoRestante < 0 ? 0 : montoRestante,
            totalPagado:totalPagado
          });
        }

        resolve(planDePagos);
      });
    }

    // async calcularPlanDePagosConCostosAdicionales(valorTotalVenta: number, monto: any, listaProductosSeleccionados: any[], costosAdicionales: any[]) {
    //   return new Promise((resolve, reject) => {
    //     const tasaEfectivaAnual = monto.valor / 100; // TEA proporcionada en el objeto monto
    //     const numeroDeCuotas = monto.numeroCuota;
    //     const periodicidad = 12; // Mensual, por ejemplo

    //     // Convertir TEA a tasa nominal periódica
    //     const tasaInteresPeriodica = Math.pow(1 + tasaEfectivaAnual, 1 / periodicidad) - 1;

    //     // Calcular la cuota fija usando la fórmula de amortización
    //     const montoDeCuotaSinRedondeo = (valorTotalVenta * tasaInteresPeriodica * Math.pow(1 + tasaInteresPeriodica, numeroDeCuotas)) /
    //       (Math.pow(1 + tasaInteresPeriodica, numeroDeCuotas) - 1);

    //     // Redondea la cuota al múltiplo de 100 más cercano
    //     const montoDeCuota = Math.ceil(montoDeCuotaSinRedondeo / 100) * 100;

    //     let planDePagos = [];
    //     let montoRestante = valorTotalVenta;
    //     let totalPagado = 0;

    //     // Obtener los nombres de los costos adicionales para crear las columnas
    //     const nombresCostosAdicionales = costosAdicionales.map(costo => costo.nombrecostoadicional);

    //     // Inicializar un objeto con los costos adicionales distribuidos para cada cuota
    //     let costosDistribuidos = nombresCostosAdicionales.reduce((acum, nombre) => {
    //       acum[nombre] = Array(numeroDeCuotas).fill(0);
    //       return acum;
    //     }, {});

    //     // Distribuir los costos adicionales en todas las cuotas
    //     costosAdicionales.forEach(costo => {
    //       for (let i = 0; i < numeroDeCuotas; i++) {
    //         costosDistribuidos[costo.nombrecostoadicional][i] = parseFloat(costo.montoDeLaCuota);
    //       }
    //     });

    //     for (let cuota = 1; cuota <= numeroDeCuotas; cuota++) {
    //       let fechaDeVencimiento = new Date();
    //       fechaDeVencimiento.setMonth(fechaDeVencimiento.getMonth() + cuota);

    //       // Calcular interés y abono a capital para la cuota actual
    //       let interesCuota = montoRestante * tasaInteresPeriodica;
    //       let abonoCapital = montoDeCuota - interesCuota;

    //       // Reducir el capital restante
    //       montoRestante -= abonoCapital;

    //       // Actualizar el total pagado
    //       totalPagado += montoDeCuota;

    //       // Crear el objeto para la cuota con los costos adicionales
    //       let cuotaObj = {
    //         numeroDeCuota: cuota,
    //         montoDeLaCuota: montoDeCuota,
    //         abonoCapital: abonoCapital,
    //         abonoInteres: interesCuota,
    //         fechaDeVencimiento: fechaDeVencimiento,
    //         capitalRestante: montoRestante < 0 ? 0 : montoRestante,
    //         totalPagado: totalPagado,
    //       };

    //       // Agregar los costos adicionales a la cuota
    //       nombresCostosAdicionales.forEach(nombre => {
    //         cuotaObj[nombre] = costosDistribuidos[nombre][cuota - 1];
    //       });
    //
    //       planDePagos.push(cuotaObj);
    //     }

    //     resolve(planDePagos);
    //   });
    // }

    async calcularPlanDePagosCostosAdicionales(valorCosto: number,numeroDeCuotas: any) {
      return new Promise((resolve, reject) => {


        let planDePagos = [];

        for (let cuota = 1; cuota <= numeroDeCuotas; cuota++) {
          let fechaDeVencimiento = new Date();
          fechaDeVencimiento.setMonth(fechaDeVencimiento.getMonth() + cuota);
          planDePagos.push({
            numeroDeCuota: cuota,
            montoDeLaCuota: valorCosto,
            fechaDeVencimiento: fechaDeVencimiento,
           });
        }

        resolve(planDePagos);
      });
    }


    async calcularPlanDePagosConIntereses(valorTotalVenta: number, monto: number, numeroDeCuotas: number, periodicidadEnCadena: string, periodoDeGracia: number, cuotasExtrasArray: any[], tasaEfectivaAnual: number) {
      return new Promise((resolve, reject) => {
          // Convertir la tasa efectiva anual a tasa nominal periódica
          const periodicidad = this.devolverNumeroDePeriodicidad(periodicidadEnCadena);
          const tasaNominalPeriodica = Math.pow(1 + tasaEfectivaAnual, 1 / periodicidad) - 1;

          // Calcular el monto de cada cuota
          let planDePagos = [];
          let montoRestante = monto;
          let totalPagado = 0;
          let montoDeCuotaActual = 0;

          // Periodo de gracia
          for (let cuota = 1; cuota <= periodoDeGracia; cuota++) {
              let fechaDeVencimiento = new Date(); // Obtener una nueva instancia de fecha para cada cuota
              fechaDeVencimiento.setMonth(fechaDeVencimiento.getMonth() + (periodicidad * (cuota))); // Cambiar la fecha de vencimiento para cada cuota
              planDePagos.push({
                  numeroDeCuota: cuota,
                  montoDeLaCuota: montoDeCuotaActual,
                  fechaDeVencimiento: fechaDeVencimiento,
                  capitalRestante: 0,
                  totalPagado: totalPagado
              });
          }

          // Calcular cuotas con intereses
          for (let cuota = 1; cuota <= numeroDeCuotas; cuota++) {
              let fechaDeVencimiento = new Date(); // Obtener una nueva instancia de fecha para cada cuota
              fechaDeVencimiento.setMonth(fechaDeVencimiento.getMonth() + (periodicidad * (cuota + periodoDeGracia))); // Cambiar la fecha de vencimiento para cada cuota

              // Calcular monto de la cuota con interés
              let interes = montoRestante * tasaNominalPeriodica;
              montoDeCuotaActual = (montoRestante / (numeroDeCuotas - cuota + 1)) + interes;

              totalPagado += montoDeCuotaActual;
              montoRestante -= (montoDeCuotaActual - interes);

              let sumaMontos = 0;

              // Iterar a través de todos los registros en planDePagos
              planDePagos.forEach(item => {
                  sumaMontos += item.montoDeLaCuota;
              });

              if (cuota === Number(numeroDeCuotas)) {
                  let valorUltimaCalculado = valorTotalVenta - sumaMontos < 0 ? 0 : (valorTotalVenta - sumaMontos);
                  planDePagos.push({
                      numeroDeCuota: cuota + periodoDeGracia,
                      montoDeLaCuota: valorUltimaCalculado < 0 ? 0 : valorUltimaCalculado,
                      fechaDeVencimiento: fechaDeVencimiento,
                      capitalRestante: 0,
                      totalPagado: 0
                  });
              } else {
                  let montoDeCuotaCalculado = valorTotalVenta - Number(sumaMontos) > 0 ? montoDeCuotaActual : 0;
                  montoDeCuotaCalculado = montoDeCuotaCalculado + sumaMontos > valorTotalVenta ? valorTotalVenta - sumaMontos : montoDeCuotaCalculado;
                  totalPagado = valorTotalVenta < totalPagado ? valorTotalVenta : totalPagado;
                  planDePagos.push({
                      numeroDeCuota: cuota + periodoDeGracia,
                      montoDeLaCuota: montoDeCuotaCalculado < 0 ? monto : montoDeCuotaCalculado,
                      fechaDeVencimiento: fechaDeVencimiento,
                      capitalRestante: montoRestante < 0 ? 0 : montoRestante,
                      totalPagado: montoDeCuotaCalculado === 0 ? 0 : totalPagado
                  });
              }
          }

          planDePagos[0].montoDeLaCuota = periodoDeGracia > 0 ? 0 : monto;
          resolve(planDePagos); // Resuelve la Promise con los datos del plan de pagos una vez que estén listos
      });
  }


  async calcularPlanDePagosConInteresesYCostosAdicionales(valorTotalVenta: number, monto: number, numeroDeCuotas: number, periodicidadEnCadena: string, periodoDeGracia: number, cuotasExtrasArray: any[], tasaEfectivaAnual: number, costosAdicionales: any[]): Promise<any[]> {
    const periodicidad = this.devolverNumeroDePeriodicidad(periodicidadEnCadena);
    const tasaNominalPeriodica = Math.pow(1 + tasaEfectivaAnual, 1 / periodicidad) - 1;

    let planDePagos = [];
    let montoRestante = monto;
    let totalPagado = 0;
    let montoDeCuotaActual = 0;

    const totalCostosAdicionales = costosAdicionales.reduce((acc, costo) => acc + costo.valor, 0);
    const costoAdicionalPorCuota = totalCostosAdicionales / numeroDeCuotas;

    let interesAcumuladoDuranteGracia = 0;

    // Generar cuotas durante el periodo de gracia
    for (let cuota = 1; cuota <= periodoDeGracia; cuota++) {
      let fechaDeVencimiento = new Date();
      fechaDeVencimiento.setDate(fechaDeVencimiento.getDate() + Math.round(30 * periodicidad * cuota));

      let interes = montoRestante * tasaNominalPeriodica;
      interesAcumuladoDuranteGracia += interes;

      planDePagos.push({
        numeroDeCuota: cuota,
        montoDeLaCuota: 0,
        fechaDeVencimiento: fechaDeVencimiento,
        capitalRestante: monto,
        totalPagado: 0,
        interes: interes,
        costosAdicionales: []
      });
    }

    // Generar cuotas después del periodo de gracia
    for (let cuota = 1; cuota <= numeroDeCuotas; cuota++) {
      let fechaDeVencimiento = new Date();
      fechaDeVencimiento.setDate(fechaDeVencimiento.getDate() + Math.round(30 * periodicidad * (cuota + periodoDeGracia)));

      let interes = montoRestante * tasaNominalPeriodica;
      montoDeCuotaActual = (montoRestante / (numeroDeCuotas - cuota + 1)) + interes + (interesAcumuladoDuranteGracia / numeroDeCuotas);

      totalPagado += montoDeCuotaActual;
      montoRestante -= (montoDeCuotaActual - interes - (interesAcumuladoDuranteGracia / numeroDeCuotas));

      const costosAdicionalesPorCuota = costosAdicionales.map(costo => ({ nombre: costo.nombre, valor: costoAdicionalPorCuota }));

      planDePagos.push({
        numeroDeCuota: cuota + periodoDeGracia,
        montoDeLaCuota: montoDeCuotaActual + costoAdicionalPorCuota,
        fechaDeVencimiento: fechaDeVencimiento,
        capitalRestante: montoRestante,
        totalPagado: totalPagado,
        interes: interes,
        costosAdicionales: costosAdicionalesPorCuota
      });
    }

    return planDePagos;
  }

  calcularFechaDeVencimiento(periodicidad: number, cuota: number) {
    let fechaOriginal = new Date();
    let mesesAAgregar: number;

    if (periodicidad === 0.5) {
      // Periodicidad quincenal (15 días por quincena)
      let diasAAgregar = 15 * cuota;
      fechaOriginal.setDate(fechaOriginal.getDate() + diasAAgregar);
      return fechaOriginal;
    } else if (periodicidad === 1) {
      // Periodicidad mensual (1 mes por cuota)
      mesesAAgregar = 1 * cuota;
      fechaOriginal.setMonth(fechaOriginal.getMonth() + mesesAAgregar);
    } else if (periodicidad === 2) {
      // Bimensual (2 meses por cuota)
      mesesAAgregar = 2 * cuota;
      fechaOriginal.setMonth(fechaOriginal.getMonth() + mesesAAgregar);
    } else if (periodicidad === 3) {
      // Trimestral (3 meses por cuota)
      mesesAAgregar = 3 * cuota;
      fechaOriginal.setMonth(fechaOriginal.getMonth() + mesesAAgregar);
    } else {
      // Valor por defecto (mensual)
      mesesAAgregar = 1 * cuota;
      fechaOriginal.setMonth(fechaOriginal.getMonth() + mesesAAgregar);
    }

    // Validamos si el día se ha ajustado por el mes (ejemplo: febrero)
    let diaOriginal = new Date().getDate();
    if (fechaOriginal.getDate() !== diaOriginal) {
      // Si el día ha cambiado, lo ajustamos al día original
      fechaOriginal.setDate(Math.min(diaOriginal, this.obtenerUltimoDiaDelMes(fechaOriginal)));
    }

    return fechaOriginal;
  }

  obtenerUltimoDiaDelMes(fecha: Date): number {
    let year = fecha.getFullYear();
    let month = fecha.getMonth() + 1;
    return new Date(year, month, 0).getDate();
  }


  obtenerPeriodicidad(periodicidadParcial: any): number {
    if (periodicidadParcial === 0.5) {
      return 24; // 24 pagos por año (quincenal)
    } else if (periodicidadParcial === 1) {
      return 12; // 12 pagos por año (mensual)
    } else if (periodicidadParcial === 2) {
      return 6; // 6 pagos por año (bimestral)
    } else if (periodicidadParcial === 3) {
      return 4; // 4 pagos por año (trimestral)
    } else {
      return 12; // Por defecto mensual
    }
  }

  async calcularPlanDePagosConCostosAdicionales(
    valorTotalVenta: number,
    monto: any,
    listaProductosSeleccionados: any[],
    costosAdicionales: any[],
    periodicidadParcial: any,
    diaDePago: number,
    costosAdicionalesDiaDePago: any[],
    planSepare: string = 'N'
  ) {
    return new Promise((resolve, reject) => {
      let tasaEfectivaAnual = monto.valor / 100; // TEA proporcionada en el objeto monto
      const numeroDeCuotas = monto.numeroCuota;
      const periodicidad = this.obtenerPeriodicidad(periodicidadParcial);

      // Verificar si el plan es "planSepare"
      if (planSepare === 'S') {
        tasaEfectivaAnual = 0; // No se cobran intereses
      }

      // Convertir TEA a tasa nominal periódica
      const tasaInteresPeriodica = tasaEfectivaAnual === 0 ? 0 : Math.pow(1 + tasaEfectivaAnual, 1 / periodicidad) - 1;

      // Calcular la cuota fija
      let montoDeCuota: number;
      if (tasaEfectivaAnual === 0) {
        // Si la tasa es 0, dividimos el valor total equitativamente entre las cuotas
        montoDeCuota = Math.round(valorTotalVenta / numeroDeCuotas);
      } else {
        const montoDeCuotaSinRedondeo =
          (valorTotalVenta * tasaInteresPeriodica * Math.pow(1 + tasaInteresPeriodica, numeroDeCuotas)) /
          (Math.pow(1 + tasaInteresPeriodica, numeroDeCuotas) - 1);
        montoDeCuota = Math.round(montoDeCuotaSinRedondeo);
      }

      let planDePagos = [];
      let montoRestante = valorTotalVenta;
      let totalPagado = 0;

      // Inicializar un objeto para almacenar los costos adicionales distribuidos en todas las cuotas
      let costosDistribuidos = {};

      let fechaDeVencimientoAnterior = new Date();
      let fechaNueva = new Date();
      let diasTranscurridos = 0;

      if (diaDePago !== 0) {
        if (diaDePago < fechaDeVencimientoAnterior.getDate()) {
          fechaNueva = this.fechaCambio(fechaDeVencimientoAnterior, diaDePago);
          fechaNueva.setMonth(fechaNueva.getMonth() + 1);
        } else {
          fechaNueva = this.fechaCambio(fechaDeVencimientoAnterior, diaDePago);
        }

        // Calcular la diferencia en milisegundos
        let diferenciaEnMilisegundos = fechaNueva.getTime() - fechaDeVencimientoAnterior.getTime();

        // Convertir la diferencia de milisegundos a días
        diasTranscurridos = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24));
      }

      let fechaDeVencimiento = undefined;
      let fechaBase: Date = new Date(); // Fecha base actual

      // Generar el plan de pagos
      for (let cuota = 1; cuota <= numeroDeCuotas; cuota++) {
        if (cuota === 1 && diaDePago !== 0) {
          fechaDeVencimiento = fechaNueva;
          fechaBase = new Date(fechaDeVencimiento); // Actualizamos la fecha base
        } else {
          // Para las cuotas siguientes, calculamos basado en la fecha base ajustada
          fechaDeVencimiento = this.calcularFechaDeVencimientoConBase(fechaBase, periodicidadParcial, cuota, diaDePago);
          if (diaDePago !== 0) {
            fechaBase = new Date(fechaDeVencimiento); // Actualizamos la fecha base
          }
        }

        // Calcular interés y abono a capital para la cuota actual
        let interesCuota = montoRestante * tasaInteresPeriodica;
        let abonoCapital = montoDeCuota - interesCuota;

        if (cuota === 1 && diaDePago !== 0) {
          let diasPorPeriodo = this.devolverDiasDelPeriodo(periodicidadParcial);
          let interesPorDia = interesCuota / diasPorPeriodo;
          let interesTranscurrido = interesPorDia * diasTranscurridos;
          interesTranscurrido = interesTranscurrido / numeroDeCuotas;
          let interesRedondeado = Math.ceil(interesTranscurrido / 100) * 100;
          if (diasPorPeriodo > diasTranscurridos) {
            costosAdicionalesDiaDePago = [];
          } else {
            // Actualizar el campo 'valorcostosadicional' con el interés calculado
            if (costosAdicionalesDiaDePago && costosAdicionalesDiaDePago.length > 0) {
              costosAdicionalesDiaDePago[0].valorcostosadicional = interesRedondeado;
              costosAdicionalesDiaDePago[0].montoDeLaCuota = interesRedondeado;
              costosAdicionales.push(costosAdicionalesDiaDePago[0]);
            }
          }
        }

        // Reducir el capital restante
        montoRestante -= abonoCapital;

        // Actualizar el total pagado
        totalPagado += montoDeCuota;

        // Crear el objeto para la cuota actual
        let cuotaObj = {
          numeroDeCuota: cuota,
          montoDeLaCuota: montoDeCuota,
          abonoCapital: abonoCapital,
          abonoInteres: interesCuota,
          fechaDeVencimiento: fechaDeVencimiento,
          capitalRestante: montoRestante < 0 ? 0 : montoRestante,
          totalPagado: totalPagado,
          tasaPeriodica: tasaInteresPeriodica,
          tasaEfectivaAnual: tasaEfectivaAnual
        };

        costosAdicionales.forEach(costo => {
          if (!costosDistribuidos[costo.nombrecostoadicional]) {
            costosDistribuidos[costo.nombrecostoadicional] = Array(numeroDeCuotas).fill(parseFloat(costo.montoDeLaCuota));
            costosDistribuidos['tipo'] = Array(numeroDeCuotas).fill(costo.tipo);
          }
        });
        if(planSepare !== 'S') {
          // Agregar los costos adicionales como columnas adicionales en cada cuota
          for (let nombre in costosDistribuidos) {
            cuotaObj[nombre] = costosDistribuidos[nombre][cuota - 1];
          }
        }

        planDePagos.push(cuotaObj);
      }

      resolve(planDePagos);
    });
  }


  // async calcularPlanDePagosConCostosAdicionales(
  //   valorTotalVenta: number,
  //   monto: any,
  //   listaProductosSeleccionados: any[],
  //   costosAdicionales: any[],
  //   periodicidadParcial:any,
  //   diaDePago:number,
  //   costosAdicionalesDiaDePago: any[],
  //   planSepare:string = 'N'
  // ) {
  //   return new Promise((resolve, reject) => {
  //     let tasaEfectivaAnual = monto.valor / 100; // TEA proporcionada en el objeto monto
  //     const numeroDeCuotas = monto.numeroCuota;
  //     const periodicidad = this.obtenerPeriodicidad(periodicidadParcial);

  //         // Verificar si el plan es "planSepare"
  //     if (planSepare === 'S') {
  //         tasaEfectivaAnual = 0; // No se cobran intereses
  //     }

  //     // Convertir TEA a tasa nominal periódica
  //     const tasaInteresPeriodica = Math.pow(1 + tasaEfectivaAnual, 1 / periodicidad) - 1;

  //     let tasaPeriodica = tasaInteresPeriodica;

  //     // Calcular la cuota fija usando la fórmula de amortización
  //     const montoDeCuotaSinRedondeo =
  //       (valorTotalVenta * tasaInteresPeriodica * Math.pow(1 + tasaInteresPeriodica, numeroDeCuotas)) /
  //       (Math.pow(1 + tasaInteresPeriodica, numeroDeCuotas) - 1);

  //     const montoDeCuota =  Math.round(montoDeCuotaSinRedondeo);
  //     let planDePagos = [];
  //     let montoRestante = valorTotalVenta;
  //     let totalPagado = 0;

  //     // Inicializar un objeto para almacenar los costos adicionales distribuidos en todas las cuotas
  //     let costosDistribuidos = {};


  //     let fechaDeVencimientoAnterior = new Date();
  //     let fechaNueva = new Date()
  //     let diasTranscurridos = 0
  //     if (diaDePago !== 0) {
  //       if (diaDePago < fechaDeVencimientoAnterior.getDate()) {

  //         fechaNueva = this.fechaCambio(fechaDeVencimientoAnterior, diaDePago);
  //         fechaNueva.setMonth(fechaNueva.getMonth() + 1);
  //       } else {
  //         fechaNueva = this.fechaCambio(fechaDeVencimientoAnterior, diaDePago);
  //       }

  //       // Calcular la diferencia en milisegundos
  //       let diferenciaEnMilisegundos = fechaNueva.getTime() - fechaDeVencimientoAnterior.getTime();

  //       // Convertir la diferencia de milisegundos a días
  //       diasTranscurridos = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60 * 24));
  //     }

  //     let fechaDeVencimiento = undefined
  //     let fechaBase: Date = new Date(); // Fecha base actual
  //     // Generar el plan de pagos
  //     for (let cuota = 1; cuota <= numeroDeCuotas; cuota++) {
  //       if (cuota === 1 && diaDePago !== 0) {
  //         fechaDeVencimiento = fechaNueva
  //         fechaBase = new Date(fechaDeVencimiento); // Actualizamos la fecha base
  //       } else {
  //         // Para las cuotas siguientes, calculamos basado en la fecha base ajustada
  //         fechaDeVencimiento = this.calcularFechaDeVencimientoConBase(fechaBase, periodicidadParcial, cuota, diaDePago);
  //         if(diaDePago !==0) {
  //           fechaBase = new Date(fechaDeVencimiento); // Actualizamos la fecha base
  //         }
  //       }

  //       // Calcular interés y abono a capital para la cuota actual
  //       let interesCuota = montoRestante * tasaInteresPeriodica;
  //       let abonoCapital = montoDeCuota - interesCuota;
  //       if (cuota === 1 && diaDePago !== 0) {
  //         let diasPorPeriodo = this.devolverDiasDelPeriodo(periodicidadParcial)
  //         let interesPorDia = interesCuota / diasPorPeriodo;
  //         let interesTranscurrido = interesPorDia * diasTranscurridos;
  //         interesTranscurrido = interesTranscurrido / numeroDeCuotas
  //         let interesRedondeado = Math.ceil(interesTranscurrido / 100) * 100;
  //         if(diasPorPeriodo>diasTranscurridos){
  //           costosAdicionalesDiaDePago = []
  //         } else {
  //            // Actualizar el campo 'valorcostosadicional' con el interés calculado
  //          if(costosAdicionalesDiaDePago && costosAdicionalesDiaDePago.length>0) {
  //           costosAdicionalesDiaDePago[0].valorcostosadicional = interesRedondeado;
  //           costosAdicionalesDiaDePago[0].montoDeLaCuota = interesRedondeado;
  //           costosAdicionales.push(costosAdicionalesDiaDePago[0])
  //          }
  //         }
  //       }

  //       // Reducir el capital restante
  //       montoRestante -= abonoCapital;

  //       // Actualizar el total pagado
  //       totalPagado += montoDeCuota;

  //       // Crear el objeto para la cuota actual
  //       let cuotaObj = {
  //         numeroDeCuota: cuota,
  //         montoDeLaCuota: montoDeCuota,
  //         abonoCapital: abonoCapital,
  //         abonoInteres: interesCuota,
  //         fechaDeVencimiento: fechaDeVencimiento,
  //         capitalRestante: montoRestante < 0 ? 0 : montoRestante,
  //         totalPagado: totalPagado,
  //         tasaPeriodica: tasaPeriodica,
  //         tasaEfectivaAnual:tasaEfectivaAnual
  //       };
  //       costosAdicionales.forEach(costo => {
  //         if (!costosDistribuidos[costo.nombrecostoadicional]) {
  //           costosDistribuidos[costo.nombrecostoadicional] = Array(numeroDeCuotas).fill(parseFloat(costo.montoDeLaCuota));
  //           costosDistribuidos['tipo'] = Array(numeroDeCuotas).fill(costo.tipo);
  //         }
  //       });


  //       // Agregar los costos adicionales como columnas adicionales en cada cuota
  //       for (let nombre in costosDistribuidos) {
  //         cuotaObj[nombre] = costosDistribuidos[nombre][cuota - 1];
  //       }
  //       planDePagos.push(cuotaObj);
  //     }

  //     resolve(planDePagos);
  //   });
  // }




  calcularFechaDeVencimientoConBase(fechaBase: Date, periodicidad: number, cuota: number, diaDePago: number =0) {
    let fechaAjustada = new Date(fechaBase);
    let mesesAAgregar: number;
    let diasAAgregar = 0
    if (periodicidad === 0.5) {
      // Quincenal
      // let diasAAgregar = 15 * cuota;

      if(diaDePago!==0) {
        diasAAgregar = 15;
      } else {
        diasAAgregar = 15 * cuota;
      }
      fechaAjustada.setDate(fechaAjustada.getDate() + diasAAgregar);
      return fechaAjustada
    } else {
      // Mensual o superior
      if (periodicidad === 1 && diaDePago!==0) {
        diasAAgregar = 30;
        fechaAjustada.setDate(fechaAjustada.getDate() + diasAAgregar);
        return fechaAjustada
      }
      if (periodicidad === 2 && diaDePago!==0) {
        diasAAgregar = 60;
        fechaAjustada.setDate(fechaAjustada.getDate() + diasAAgregar);
        return fechaAjustada
      }
      if (periodicidad === 3 && diaDePago!==0) {
        diasAAgregar = 90;
        fechaAjustada.setDate(fechaAjustada.getDate() + diasAAgregar);
        return fechaAjustada
      }
      mesesAAgregar = Math.floor(periodicidad) * cuota;
      fechaAjustada.setMonth(fechaAjustada.getMonth() + mesesAAgregar);
    }

    return fechaAjustada;
  }


  fechaCambio(fecha: Date, diaDePago: number): Date {
    let nuevaFecha = new Date(fecha);
    nuevaFecha.setDate(diaDePago); // Cambiamos al día de pago
    return nuevaFecha;
  }

  devolverDiasDelPeriodo(periodicidad:number) {
    let periodo = 0;
    if (periodicidad === 0.5) {
        periodo = 15; // Quincenal
    } else if (periodicidad === 1) {
        periodo = 30; // Mensual
    } else if (periodicidad === 2) {
        periodo = 60; // Bimestral
    } else if (periodicidad === 3) {
        periodo = 90; // Trimestral
    } else {
       return 30
    }
    return periodo
  }



}



// WEBPACK FOOTER //
// ./src/providers/simulador-cuentas-por-cobrar/simulador-cuentas-por-cobrar.ts